module.exports = "/images/icon-sliderArrowRight.svg?deb1478de1d21803b2501cc64651c90e";